import React from 'react';

const POs = () => {
    return (
        <div className="bg-white py-4 font-sans">
            <div
                className="container container max-w-xl m-auto flex flex-wrap flex-col md:flex-row items-center justify-start">
                <div className="w-full lg:w-1/2 p-3">
                    <div
                        className="flex flex-col lg:flex-row rounded overflow-hidden h-auto lg:h-32 border shadow shadow-lg">
                        <img
                            className="block h-auto w-full lg:w-24 flex-none bg-cover h-24"
                            alt='po1'
                            src="https://www.niehs.nih.gov/businesscards/photos/t_v/tyson_frederick_l.jpg"/>
                        <div
                            className="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                            <div className="text-grey-darkest font-bold text-xl mb-2 leading-loose">Fred Tyson, PhD</div>
                            <p className="text-grey-darker text-base"><a href="https://www.niehs.nih.gov/research/supported/dert/geh/tyson/index.cfm">Program Officer</a></p>
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-1/2 p-3">
                    <div
                        className="flex flex-col lg:flex-row rounded overflow-hidden h-auto lg:h-32 border shadow shadow-lg">
                        <img
                            className="block h-auto w-full lg:w-24 flex-none bg-cover"
                            alt='po2'
                            src="https://www.niehs.nih.gov/businesscards/photos/m/mcallister_kimberly_a.jpg"/>
                        <div
                            className="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                            <div className="text-grey-darkest font-bold text-xl mb-2 leading-tight">Kim McAllister, PhD</div>
                            <p className="text-grey-darker text-base"><a href="https://www.niehs.nih.gov/research/supported/dert/geh/mcallister/index.cfm">Program Officer</a></p>
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-1/2 p-3">
                    <div
                        className="flex flex-col lg:flex-row rounded overflow-hidden h-auto lg:h-32 border shadow shadow-lg">
                        <img
                            className="block h-auto w-full lg:w-24 flex-none bg-cover"
                            alt='po2'
                            src="https://www.niehs.nih.gov/businesscards/photos/d_e/duncan_christopher.jpg"/>
                        <div
                            className="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                            <div className="text-grey-darkest font-bold text-xl mb-2 leading-tight">Christopher G. Duncan, PhD</div>
                            <p className="text-grey-darker text-base"><a href="https://www.niehs.nih.gov/research/supported/dert/geh/index.cfm">Program Officer</a></p>
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-1/2 p-3">
                    <div
                        className="flex flex-col lg:flex-row rounded overflow-hidden h-auto lg:h-32 border shadow shadow-lg">
                        <img
                            className="block h-auto w-full lg:w-24 flex-none bg-cover"
                            alt='po2'
                            src="https://www.niehs.nih.gov/businesscards/photos/f_g/garton_amanda.jpg"/>
                        <div
                            className="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                            <div className="text-grey-darkest font-bold text-xl mb-2 leading-tight">Amanda Garton</div>
                            <p className="text-grey-darker text-base"><a href="https://www.niehs.nih.gov/research/supported/dert/geh/garton/index.cfm">Health Specialist</a></p>
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-1/2 p-3">
                    <div
                        className="flex flex-col lg:flex-row rounded overflow-hidden h-auto lg:h-32 border shadow shadow-lg">
                        <img
                            className="block h-auto w-full lg:w-32 flex-none bg-cover"
                            alt='po2'
                            src="https://www.genome.gov/sites/default/files/media/images/chadwick.png"/>
                        <div
                            className="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                            <div className="text-grey-darkest font-bold text-xl mb-2 leading-tight">Lisa H. Chadwick, PhD</div>
                            <p className="text-grey-darker text-base"><a href="https://www.genome.gov/staff/Lisa-Helbling-Chadwick-PhD">Former Program Officer</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default POs;